const shouldAutoDispatchFetch = (component, isMounting) => {
  return component.props.autoLoad !== false || !isMounting;
};
export default shouldAutoDispatchFetch;